import { useEffect } from "react";

const SUFFIX = "FleetOS by Graphikpro";

/** Sets the browser tab title for the current module/page.
 *  Pass a leaf title; the FleetOS suffix is appended automatically unless
 *  `bare` is true (used for the marketing landing which sets its own full title). */
export default function useDocumentTitle(title, bare = false) {
  useEffect(() => {
    if (!title) return;
    document.title = bare ? title : `${title} · ${SUFFIX}`;
  }, [title, bare]);
}
